import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { typeInterface } from 'src/app/shared/Interfaces/company';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import { Fidelity } from 'src/app/shared/Interfaces/fidelity';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { CacheService } from 'src/app/shared/services/Cache/cache.service';
import { Company, ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-fidelity',
  templateUrl: './fidelity.component.html',
  styleUrl: './fidelity.component.css'
})
export class FidelityComponent implements OnInit, AfterViewInit{
  private typeParam!: typeInterface;
  nameCompany: string = '';
  user!: Cliente;
  company!: Company;
  fidelityUser!: Fidelity;
  fidelityGet: boolean = false;
  percentageValue: number = 0;
  percentageCount: number = 0;
  userConfirmation: boolean = false;
  showLoading: boolean = false;
  showTopMenu: boolean = false;
  showModalPassword: boolean = false;
  isPasswordVisible: boolean = false;

  constructor(private router: Router,
    private connection: ConnectionService,
    private cacheService: CacheService,
    private apiService: ApiService,
    private notify: NotificationService,
    private layout: LayoutComponent,
  ){
    this.connection.typeParam$.subscribe((newTypeParam) => {
      this.typeParam = newTypeParam
    })
  }

  ngOnInit(): void {
    this.connection.fidelity$.subscribe(
      (data) =>{
        this.fidelityUser = data;
        this.fidelityGet = true;
        if(this.fidelityUser.fidelityOption == 1){
          this.calcPercentageCount();
        }
        else{
          this.calcPercentageValue();
        }

    })
    this.connection.nameCompany$.subscribe((newNameCompany) => {
      this.nameCompany = newNameCompany
    })
    this.connection.company$.subscribe((newCompany) =>{
      this.company = newCompany
      if(!this.fidelityUser){
        this.getFidelity();
      }

    })
    this.connection.user$.subscribe((User) =>{
      this.user = User;
      if(!this.fidelityUser){
        this.getFidelity();
      }
    },
    () =>{
      if(this.cacheService.getItemLocal('user_key'))
      {
        this.user = this.cacheService.getItemLocal('user_key')
      }
    })

  }

  ngAfterViewInit(): void {
    this.checkScreenSize()
  }

  goBack(){
    this.router.navigate([this.nameCompany, 'user']);
    // if(!this.fidelityContent){
    //   this.router.navigate([this.nameCompany, 'user']);
    // }
    // else{
    //   this.close.emit(true);
    // }

  }

  @HostListener('window:resize')
  onWindowResize() {
    this.checkScreenSize();
  }

  //Verifica o tamanho da tela, esconde o Menu superior se necessario
  checkScreenSize(){
    if(window.innerWidth <= 846){

      this.showTopMenu = false;
    }
    else{
      this.showTopMenu = true;
    }
    this.layout.checkScreenSize();
  }

  //tipo fidelidade 1 é por pedido
  //tipo fidelidade 0 é por valor
  getFidelity(){
    if(this.company){
      if(this.user){
        if(!this.fidelityGet)
        {
          this.apiService.getFidelity(this.user.id_customer, this.company.company.id_company).subscribe(
            (data) =>{
              console.log(data)
              this.fidelityUser = data;
              this.fidelityGet = true;
              if(this.fidelityUser.fidelityOption == 1){
                this.calcPercentageCount();
              }
              else{
                this.calcPercentageValue();
              }
              console.log(this.fidelityUser);
            },
            (error) =>{
              console.log(error);
            }
          )
        }
      }
    }

  }

  //Calcula a porcentagem
  calcPercentageCount(){
    this.percentageCount = (this.fidelityUser.ordersCount / this.fidelityUser.fidelityCount) * 100;
  }

  //Calcula o valor
  calcPercentageValue(){
    this.percentageValue = (this.fidelityUser.ordersValue / this.fidelityUser.fidelityValue) * 100;
  }

  direct(){
    this.showLoading = true
    this.apiService.requestCoupon(this.user.id_customer, this.company.company.id_company).subscribe(
      (data) =>{
        if(data.created){
          this.apiService.getUsuario(this.user.phone, this.company.company.id_company).subscribe((data) =>{this.connection.updateUser(data.response.customer)})
          this.connection.getFidelity(this.user.id_customer, this.company.company.id_company)
          setTimeout(() => {
            this.showLoading = false;
            this.router.navigateByUrl(`${this.nameCompany}/coupons`);
            this.notify.success('Prêmio resgatado com sucesso.');
          }, 1000);
        }
        else{
          this.showLoading = false;
          this.notify.error('Erro ao resgatar o prêmio.');
        }

      },
      (error) =>{
        console.log(error);
        this.showLoading = false;
        this.notify.error('Erro ao resgatar o prêmio.');
      }
    )
  }

  togglePassword() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  
}
